export default __webpack_public_path__ + "static/media/login.05288498.jpg";